import { FC, Fragment } from 'react';
import { HeaderWaffleMenuItemsProps } from './types';
import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import cx from 'classnames';
import styles from './HeaderWaffleMenuItems.module.scss';

export const HeaderWaffleMenuItems: FC<HeaderWaffleMenuItemsProps> = ({
  items,
}) => {
  return (
    <div className={cx(styles['header__waffle-menu--drawer-content'])}>
      <CatList spacing="padded">
        {items?.map(({ label, link, isActive }) => (
          <Fragment key={`${label}-${link}`}>
            <CatListItem
              key={label}
              href={link}
              isActive={isActive}
              data-testid="cat-waffle-menu-list-item"
            >
              <span className={cx(styles['header__waffle-menu--drawer-item'])}>
                {label}
              </span>
            </CatListItem>
            <hr className={cx(styles['header__waffle-menu--divider'])} />
          </Fragment>
        ))}
      </CatList>
    </div>
  );
};
